import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { SimpleModalComponent } from './simple-modal.component';
import { TranslateModule } from '../../../core/translate/translate.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    SimpleModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule
  ],
  exports: [
    SimpleModalComponent
  ],
  entryComponents: [
    SimpleModalComponent
  ]
})
export class SimpleModalModule { }
